import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { ModalFooter } from '../../../../ui/Modal/ModalFooter';
import { actionButtonStyles, RangeFilterWrapper } from '../../styled';
import { RangeFilter } from '../../../../ui/RangeFilter';

interface NewPriceProps {
  hide: () => void;
}

export const NewPrice = ({ hide }: NewPriceProps) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change, submit } = useForm();
  const priceFrom = values.price_from;
  const priceTo = values.price_to;
  const resetButtonIsDisabled = !priceFrom && !priceTo;

  const onReset = () => {
    change('price_from', '');
    change('price_to', '');
  };

  const onSubmit = () => {
    submit();
    hide();
  };

  return (
    <>
      <RangeFilterWrapper>
        <RangeFilter
          minId="new-search-form-price-from"
          minName="price_from"
          maxName="price_to"
          maxId="new-search-form-price-to"
        />
      </RangeFilterWrapper>
      <ModalFooter
        resetIsDisabled={resetButtonIsDisabled}
        onReset={onReset}
        onConfirm={onSubmit}
        resetText={t('common.reset')}
        confirmText={t('common.apply')}
        confirmCypress="apply-btn"
        resetCypress="reset-btn"
        styles={actionButtonStyles}
      />
    </>
  );
};
